<div>
    <button mat-button class="addDevicesButton colorGreenHighlight marginTop8" (click)="addDevice()">
        <mat-icon class="iconAddDevices">add_circle</mat-icon><span
            class="largeDevice">{{ 'SIDEBAR.DEVICE' | translate }}</span>
    </button>
</div>